<div class="my-profile-modal">
  <div class="section-layout" fxflex fxlayout>
    <div class="sections-vertical-left">
      <div class="section-layout-horizontal" fxflex fxlayout>
        <div class="sections-horizontal-top" fxflex="38">
          <div class="user-img">
            <img [src]="logo" alt="Avatar" class="image">
            <div (click)="changePhoto()" class="middle">
              <i class="material-icons">photo_camera</i>
              <div class="text">Change</div>
            </div>
          </div>
          <h3 class="user-name">{{user?.firstName}} {{user?.lastName}}</h3>
          <h5 class="user-email">{{email}}</h5>
        </div>
        <div class="v2"></div>
        <div class="sections-horizontal horizontal-bottom" fxflex="62">
          <div class="inner-side-menu">
            <ul class="side-menu">
              <li class="side-menu-item">
                <a (click)="activateProfile()" [ngClass]="{'active-link': myProfile}" class="item-select">
                  <i class="material-icons">person</i>
                  <span class="item-label">My profile</span>
                </a>
              </li>
              <li class="side-menu-item">
                <a (click)="activatePassword()" [ngClass]="{'active-link': changePassword}" class="item-select">
                  <i class="material-icons">lock</i>
                  <span class="item-label">Change Password</span>
                </a>
              </li>
              <li class="side-menu-item">
                <a (click)="activateSecurity()" [ngClass]="{'active-link': security}" class="item-select">
                  <i class="material-icons">security</i>
                  <span class="item-label">Security</span>
                </a>
              </li>
              <li *appPermissions="readPaymentPermission" class="side-menu-item">
                <a (click)="activateSettings()" [ngClass]="{'active-link': accountSettings}" class="item-select">
                  <i class="material-icons">payment</i>
                  <span class="item-label">My Payment Methods</span>
                </a>
              </li>
              <li class="side-menu-item">
                <a (click)="activateWorkAddress()" [ngClass]="{'active-link': workAddress}" class="item-select">
                  <i class="material-icons">business</i>
                  <span class="item-label">Work Address</span>
                </a>
              </li>
              <li class="side-menu-item" *ngIf="!isGlobalAdmin">
                <a (click)="activateLicenses()" [ngClass]="{'active-link': licenses}" class="item-select">
                  <i class="material-icons">check_circle_outline</i>
                  <span class="item-label">My Licenses</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <button (click)="cancel()" class="logout-btn" routerLink="{{logoutPath}}">
          <i class="material-icons exit-app-icon">exit_to_app</i>
          Log Out
        </button>
      </div>
    </div>

    <div class="sections-vertical" fxflex="63" style="max-width: 63%;">
      <div *ngIf="myProfile" class="section-fill">
        <div class="user-form-title d-flex justify-content-end">
          <button (click)="cancel()" class="close" data-dismiss="modal" type="button">&times;</button>
        </div>
        <div>

          <form *ngIf="myProfileFormGroup" [formGroup]="myProfileFormGroup">
            <div class="input-wrap profile-form">
              <label for="firstName">First Name <span class="required-symbol">*</span></label>
              <input appInputTrimmer formControlName="firstName" id="firstName" placeholder="First Name" type="text">
              <span *ngIf="tooltipService.getState('firstName')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('firstName', defaultRequired, defaultExists, defaultInvalid)"
                [position]="'below'"
                [fieldName]="'First Name'">
              </app-tooltip>
            </span>
            </div>
            <div class="input-wrap">
              <label for="middleName">Middle Name</label>
              <input appInputTrimmer formControlName="middleName" id="middleName" placeholder="Middle Name" type="text">
              <span *ngIf="tooltipService.getState('middleName')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('middleName', defaultRequired, defaultExists, defaultInvalid)"
                [position]="'below'"
                [fieldName]="'Middle Name'">
              </app-tooltip>
            </span>
            </div>
            <div class="input-wrap">
              <label for="lastName">Last Name <span class="required-symbol">*</span></label>
              <input appInputTrimmer formControlName="lastName" id="lastName" placeholder="Last Name" type="text">
              <span *ngIf="tooltipService.getState('lastName')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('lastName', defaultRequired, defaultExists, defaultInvalid)"
                [position]="'below'"
                [fieldName]="'Last Name'">
              </app-tooltip>
            </span>
            </div>
            <div class="input-wrap">
              <label for="userName">Username <span class="required-symbol">*</span></label>
              <input appInputTrimmer formControlName="userName" id="userName" placeholder="Username" type="text">
              <span *ngIf="tooltipService.getState('username')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('username', defaultRequired, defaultExists, defaultInvalid)"
                [position]="'below'"
                [fieldName]="'username'">
              </app-tooltip>
            </span>
            </div>
            <div class="input-wrap">
              <label for="role">Role</label>
              <input formControlName="role" id="role" placeholder="Username" type="text">
            </div>
            <div class="input-wrap">
              <label for="email">Email <span class="required-symbol">*</span></label>
              <input appInputTrimmer formControlName="email" id="email" placeholder="Email" type="email">
              <span *ngIf="tooltipService.getState('email')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('email', defaultRequired, defaultExists, invalidEmail)"
                [position]="'below'"
                [fieldName]="'email'">
              </app-tooltip>
            </span>
            </div>
            <div class="input-wrap input-mat-select">
              <div class="label-wrap">
                <label for="credentials">Credentials</label>
              </div>
              <app-credentials-select
                id="credentials"
                formControlName="credentials"
                (focusout)="myProfileFormGroup.controls.credentials.updateValueAndValidity()"
                placeholder="Credentials">
              </app-credentials-select>
            </div>
            <div class="input-wrap">
              <label>Suffix </label>
              <input appInputTrimmer formControlName="suffix" id="suffix" placeholder="Suffix" [minLength]="0"/>
              <span *ngIf="tooltipService.getState('suffix')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('suffix', defaultRequired, defaultExists, defaultInvalid)"
                [position]="'below'"
                [fieldName]="'Suffix'">
              </app-tooltip>
            </span>
            </div>
            <div *ngIf="isSurveyor" class="input-wrap input-mat-select">
              <label>Spoken Language</label>
              <app-portal-select
                formControlName="spokenLanguages"
                [items]="spokenLanguages"
                [withFilter]="true"
                [clearable]="true"
                [multiple]="true"
                placeholder="Spoken Language"
                itemId="id"
                itemName="name">
                <ng-template let-item #option>
                  {{item?.name | titlecase}}
                </ng-template>
              </app-portal-select>
            </div>
            <div *ngIf="isSurveyor || isAccreditationSpecialist || isClinicalReviewer || isSchedulingTeam"
                 class="input-wrap input-mat-select">
              <label>Programs <span class="required-symbol">*</span></label>
              <app-portal-select
                formControlName="programs"
                [items]="programs"
                [withFilter]="true"
                [multiple]="true"
                [required]="true"
                [showMessage]="false"
                (onSelectionChange)="getCheckedAssigment($event)"
                placeholder="Programs"
                itemId="id"
                itemName="description">
                <ng-template let-item #option>
                  {{item?.description}}
                </ng-template>
              </app-portal-select>
              <span *ngIf="tooltipService.getState('programs')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('programs', defaultRequired, defaultExists, defaultInvalid)"
                [position]="'below'"
                [fieldName]="'Programs'">
              </app-tooltip>
            </span>
            </div>
            <div *ngIf="!isGlobalAdmin" class="input-wrap input-mat-select">
              <label>Specialties</label>
              <app-portal-select
                formControlName="specialties"
                [items]="specialties"
                [withFilter]="true"
                [multiple]="true"
                [showMessage]="false"
                placeholder="Specialties"
                itemId="id"
                itemName="name">
                <ng-template let-item #option>
                  {{item?.name}}
                </ng-template>
              </app-portal-select>
            </div>
            <div *ngIf="isSurveyor" class="input-wrap input-mat-select">
              <label>Survey Type <span class="required-symbol">*</span></label>
              <app-portal-select
                formControlName="surveyTypes"
                [items]="surveyTypes"
                [withFilter]="true"
                [multiple]="true"
                [required]="true"
                [showMessage]="false"
                placeholder="Survey type"
                itemId="key"
                itemName="value">
                <ng-template let-item #option>
                  {{item?.value}}
                </ng-template>
              </app-portal-select>
              <span *ngIf="tooltipService.getState('surveyTypes')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('surveyTypes', defaultRequired, defaultExists, defaultInvalid)"
                [position]="'below'"
                [fieldName]="'Survey Types'">
              </app-tooltip>
            </span>
            </div>

            <div *ngIf="!isGlobalAdmin" class="input-wrap input-mat-select">
              <div class="label-wrap">
                <label>Certifying Board </label>
              </div>
              <app-portal-select
                id="certifyingBoard"
                formControlName="certifyingBoard"
                [items]="certifyingBoardData"
                [withFilter]="true"
                [clearable]="true"
                (selectionChange)="onCertifyingBoardChange($event)"
                placeholder="Certifying Board"
                itemId="id"
                itemName="name">
                <ng-template let-item #option>
                  {{item?.name}}
                </ng-template>
              </app-portal-select>
            </div>
            <div *ngIf="!isGlobalAdmin" class="input-wrap input-mat-select">
              <div class="label-wrap">
                <label>Member Board <span class="required-symbol">*</span></label>
              </div>
              <app-portal-select
                id="memberBoard"
                formControlName="memberBoard"
                [items]="memberBoardData"
                [withFilter]="true"
                placeholder="Member Board"
                itemId="id"
                itemName="name">
                <ng-template let-item #option>
                  {{item?.name}}
                </ng-template>
              </app-portal-select>
              <span *ngIf="tooltipService.getState('memberBoard')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('memberBoard', defaultRequired, defaultExists, defaultInvalid)"
                [position]="'below'"
                [fieldName]="'Member Board'">
              </app-tooltip>
            </span>
            </div>
          </form>
          <div class="save-changes">
            <cmp-button
              (onClick)="saveProfile()"
              class="outline-primary"
              text="Save Changes"
              [loading]="saveBtnLoading">
            </cmp-button>
          </div>
        </div>
      </div>

      <div *ngIf="changePassword" class="section-fill">
        <div class="user-form-title d-flex justify-content-end">
          <button (click)="cancel()" class="close" data-dismiss="modal" type="button">&times;</button>
        </div>

        <div>
          <form *ngIf="changePasswordFormGroup" [formGroup]="changePasswordFormGroup">
            <div class="input-wrap profile-form">
              <label for="currentPassword">Current Password <span class="required-symbol">*</span></label>
              <input appInputTrimmer formControlName="currentPassword" id="currentPassword"
                     placeholder="Current Password" type="{{hideCurrentPassword ? 'password' : 'text'}}">
              <mat-icon matSuffix
                        (click)="hideCurrentPassword = !hideCurrentPassword">{{hideCurrentPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
              <span *ngIf="changePasswordFormGroup.controls.currentPassword.invalid &&
                    (changePasswordFormGroup.controls.currentPassword.dirty || changePasswordFormGroup.controls.currentPassword.touched)"
                    class="error-message">
              </span>
            </div>
            <div class="input-wrap">
              <label for="newPassword">New Password <span class="required-symbol">*</span></label>
              <input appInputTrimmer formControlName="newPassword" id="newPassword" placeholder="New Password"
                     type="{{hideNewPassword ? 'password' : 'text'}}">
              <mat-icon matSuffix
                        (click)="hideNewPassword = !hideNewPassword">{{hideNewPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
<!--              <span *ngIf="tooltipService.getState('newPassword')">-->
<!--                <app-tooltip-->
<!--                  [errorMessages]="tooltipService.inputValidation('newPassword', defaultRequired, defaultExists, invalidPassword)"-->
<!--                  [position]="'below'"-->
<!--                  [fieldName]="'Password'">-->
<!--                </app-tooltip>-->
<!--              </span>-->
              <span *ngIf="changePasswordFormGroup.controls.newPassword.invalid &&
                    (changePasswordFormGroup.controls.newPassword.dirty || changePasswordFormGroup.controls.newPassword.touched)"
                    class="error-message">
                <span *ngIf="changePasswordFormGroup.get('newPassword').hasError('required')">
                  This field is required
                </span>
                <span
                  *ngIf="changePasswordFormGroup.get('newPassword').hasError('minlength')">
                  Password must have a minimum of 8 characters
                </span>
                <span
                  *ngIf="changePasswordFormGroup.get('newPassword').hasError('pattern') && !(changePasswordFormGroup.get('newPassword').hasError('minlength'))">
                  Password must contain at least one number and one character!
                </span>
              </span>
            </div>

            <div class="input-wrap">
              <label for="confirmNewPassword">Confirm New Password <span class="required-symbol">*</span></label>
              <input appInputTrimmer formControlName="confirmNewPassword" id="confirmNewPassword"
                     placeholder="Confirm Password" type="{{hideConfirmPassword ? 'password' : 'text'}}">
              <mat-icon matSuffix
                        (click)="hideConfirmPassword = !hideConfirmPassword">{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
              <span *ngIf="changePasswordFormGroup.controls.confirmNewPassword.invalid &&
                    (changePasswordFormGroup.controls.confirmNewPassword.dirty || changePasswordFormGroup.controls.confirmNewPassword.touched)"
                    class="error-message">
                <span *ngIf="changePasswordFormGroup.get('confirmNewPassword').hasError('required'); else mustMatch">
                    This field is required
                </span>
                <ng-template #mustMatch>
                  <span
                    *ngIf="changePasswordFormGroup.get('confirmNewPassword') !== changePasswordFormGroup.get('newPassword')">
                    Passwords must match.
                  </span>
                </ng-template>
              </span>
            </div>
          </form>

          <div class="save-changes">
            <cmp-button
              (onClick)="savePassword()"
              class="outline-primary"
              text="Update Password"
              [loading]="updateBtnLoading">
            </cmp-button>
          </div>
        </div>
      </div>

      <div *ngIf="security" class="section-fill">
        <div class="user-form-title d-flex justify-content-end">
          <button (click)="cancel()" class="close" data-dismiss="modal" type="button">&times;</button>
        </div>
        <div class="security-section">
          <h5 class="security-title">Two-Factor Authentication</h5>
          <p class="security-description">Add an extra layer of security to your account. When enabled, you'll need to enter a verification code sent to your email during login.</p>

          <div class="two-factor-toggle">
            <mat-slide-toggle
              [checked]="twoFactorEnabled"
              (change)="onToggleTwoFactor($event)"
              [disabled]="verifyingCode"
              color="primary">
              {{twoFactorEnabled ? 'Enabled' : 'Disabled'}}
            </mat-slide-toggle>
          </div>

          <div *ngIf="showVerification" class="verification-section">
            <p class="verification-message">A verification code has been sent to your email. Please enter it below to enable two-factor authentication.</p>

            <div class="code-inputs" (paste)="onPaste($event)">
              <input id="profile-digit1" [formControl]="digit1" type="text" maxlength="1" class="code-input"
                     (keyup)="onDigitInput($event, 'profile-digit2', null)"/>
              <input id="profile-digit2" [formControl]="digit2" type="text" maxlength="1" class="code-input"
                     (keyup)="onDigitInput($event, 'profile-digit3', 'profile-digit1')"/>
              <input id="profile-digit3" [formControl]="digit3" type="text" maxlength="1" class="code-input"
                     (keyup)="onDigitInput($event, 'profile-digit4', 'profile-digit2')"/>
              <input id="profile-digit4" [formControl]="digit4" type="text" maxlength="1" class="code-input"
                     (keyup)="onDigitInput($event, 'profile-digit5', 'profile-digit3')"/>
              <input id="profile-digit5" [formControl]="digit5" type="text" maxlength="1" class="code-input"
                     (keyup)="onDigitInput($event, 'profile-digit6', 'profile-digit4')"/>
              <input id="profile-digit6" [formControl]="digit6" type="text" maxlength="1" class="code-input"
                     (keyup)="onDigitInput($event, null, 'profile-digit5')"/>
            </div>

            <div class="verification-actions">
              <cmp-button
                (onClick)="onVerifyCode()"
                class="outline-primary"
                text="Verify"
                [loading]="verifyingCode">
              </cmp-button>

              <div class="resend-section">
                <p *ngIf="!resendDisabled">
                  Didn't receive the code? <a (click)="onResendCode()" class="g-cursor-pointer resend-link">Resend Code</a>
                </p>
                <p *ngIf="resendDisabled">
                  Resend code in <strong>{{resendCountdown}}s</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="accountSettings" class="section-fill">
        <div class="user-form-title d-flex justify-content-end mb-30">
          <button (click)="cancel()" class="close" data-dismiss="modal" type="button">&times;</button>
        </div>
        <div>

          <div class="ucx-accordion">
            <div class="ucx-accordion-header">
              <div class="title-icon">
                <p class="m-0 stripe-payment-title">Payment Methods</p>
              </div>
              <div class="add-new">
                <img src="assets/images/cards/visa.svg">
                <img src="assets/images/cards/maestro.svg">
                <img src="assets/images/cards/american-express.svg">
              </div>
            </div>
            <div class="ucx-accordion-header">
              <div class="title-icon">
                <p class="safe-money-transfer">Safe money transfer using your bank account</p>
              </div>
              <div class="add-new">
                <a (click)="onAddNewPaymentMethod()" class="add-new-link">Add New</a>
              </div>
            </div>
            <div [ngClass]="{'ucx-accordion-body': true, 'card-empty': (!paymentMethods || !paymentMethods.length) }">
              <ul *ngIf="paymentMethods?.length">
                <li *ngFor="let paymentMethod of paymentMethods; let i = index"
                    [ngClass]="{'stripe-card': true, 'card-active': paymentMethod.id === defaultPaymentMethodId }">
                  <div class="card-item">
                    <div class="card-item-info">
                      <div class="card-image">
                        <img [alt]="isBankAccount(paymentMethod) ? 'Bank account' : paymentMethod.brand"
                             [src]="getPaymentMethodIcon(paymentMethod)">
                      </div>
                      <div class="card-info">
                        <p class="payment-method-primary">
                          <span class="card-number">******** {{ paymentMethod.last4 }}</span>
                          <span class="card-expiry-cvc">{{ getPaymentMethodPrimaryDetail(paymentMethod) }}</span>
                        </p>
                        <p *ngIf="isBankAccount(paymentMethod)" class="payment-method-secondary">
                          {{ getPaymentMethodSecondaryDetail(paymentMethod) }}
                        </p>
                        <div *ngIf="isBankAccount(paymentMethod)" class="payment-method-status">
                          <span class="status-badge" [ngClass]="{
                            'status-active': paymentMethod.status === 'active',
                            'status-action': paymentMethod.status === 'requires_action',
                            'status-failed': paymentMethod.status === 'failed'
                          }">{{ getPaymentMethodStatusLabel(paymentMethod) }}</span>
                          <a *ngIf="canVerifyPaymentMethod(paymentMethod)"
                             (click)="openVerificationUrl(paymentMethod)"
                             class="verify-link">Verify now</a>
                        </div>
                      </div>
                    </div>
                    <div class="card-item-actions">
                      <ul>
                        <li *ngIf="paymentMethod.id === defaultPaymentMethodId" class="active card-default">
                          <span class="set-default">Default</span>
                          <i (click)="onOpenDeleteModalPaymentMethod(paymentMethod)" class="material-icons delete-icon">delete</i>
                        </li>
                        <li *ngIf="paymentMethod.id !== defaultPaymentMethodId" class="card-default">
                          <a *ngIf="canSetPaymentMethodDefault(paymentMethod)"
                             (click)="onSetPaymentMethodDefault(paymentMethod.id)"
                             class="set-default">Set Default</a>
                          <i (click)="onOpenDeleteModalPaymentMethod(paymentMethod)" class="material-icons delete-icon">delete</i>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
              </ul>
              <div *ngIf="(!paymentMethods || !paymentMethods.length)" class="card_empty">
                <img class="no-card-img" src="assets/images/no-credit-card.svg">
                <p>You do not have any Payment Methods added, once you add your Payment Methods, they will show here!</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="workAddress" class="section-fill">
        <div class="user-form-title d-flex justify-content-end">
          <button (click)="cancel()" class="close" data-dismiss="modal" type="button">&times;</button>
        </div>
        <div>

          <form *ngIf="workAddressFormGroup" [formGroup]="workAddressFormGroup">
            <div class="input-wrap">
              <label for="workStreet1">Address Line 1 <span class="required-symbol">*</span></label>
              <input appInputTrimmer formControlName="workStreet1" id="workStreet1" placeholder="Address Line 1"/>
              <span *ngIf="tooltipService.getState('workStreet1')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('workStreet1', defaultRequired, defaultExists, invalidAddress)"
                [position]="'below'"
                [fieldName]="'Address Line 1'">
              </app-tooltip>
            </span>
            </div>
            <div class="input-wrap">
              <label for="workStreet2">Address Line 2</label>
              <input appInputTrimmer formControlName="workStreet2" id="workStreet2" placeholder="Address Line 2"/>
              <span *ngIf="tooltipService.getState('workStreet2')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('workStreet2', defaultRequired, defaultExists, invalidAddress)"
                [position]="'below'"
                [fieldName]="'Address Line 2'">
              </app-tooltip>
            </span>
            </div>
            <div class="input-wrap">
              <label for="workZipCode">Postal Code <span class="required-symbol">*</span></label>
              <input appInputTrimmer formControlName="workZipCode" id="workZipCode" placeholder="Postal Code"/>
              <span *ngIf="tooltipService.getState('workZipCode')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('workZipCode', defaultRequired, defaultExists, invalidZip)"
                [position]="'below'"
                [fieldName]="'Postal Code'">
              </app-tooltip>
            </span>
            </div>
            <div class="input-wrap">
              <label for="workCity">City <span class="required-symbol">*</span></label>
              <input appInputTrimmer id="workCity" formControlName="workCity" placeholder="City"/>
              <span *ngIf="tooltipService.getState('workCity')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('workCity', defaultRequired, defaultExists, invalidCity)"
                [position]="'below'"
                [fieldName]="'City'">
              </app-tooltip>
            </span>
            </div>
            <div class="input-wrap input-mat-select">
              <label for="workState">State <span class="required-symbol">*</span></label>
              <app-portal-select
                id="workState"
                formControlName="workState"
                [items]="stateList"
                [withFilter]="true"
                [clearable]="true"
                placeholder="State"
                itemId="id"
                itemName="name"
                (selectionChange)="getCounties(workAddressFormGroup.get('workState'), workAddressFormGroup.get('workCounty'), 'workCounty', $event?.source?.value)">
                <ng-template let-item #option>
                  {{item?.name}}
                </ng-template>
              </app-portal-select>
              <span *ngIf="tooltipService.getState('workCity')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('workCity', defaultRequired, defaultExists, invalidCity)"
                [position]="'below'"
                [fieldName]="'City'">
              </app-tooltip>
            </span>
            </div>
            <div class="input-wrap input-mat-select">
              <label for="workCounty">County <span class="required-symbol">*</span></label>
              <app-portal-select
                id="workCounty"
                formControlName="workCounty"
                [items]="workCountyList"
                [withFilter]="true"
                [clearable]="true"
                placeholder="County"
                itemId="id"
                itemName="name">
                <ng-template let-item #option>
                  {{item?.name}}
                </ng-template>
              </app-portal-select>
              <span *ngIf="tooltipService.getState('workCounty')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('workCounty', defaultRequired, defaultExists, defaultInvalid)"
                [position]="'below'"
                [fieldName]="'County'">
              </app-tooltip>
            </span>
            </div>
            <div class="input-wrap input-mat-select">
              <label for="workCountry">Country <span class="required-symbol">*</span></label>
              <app-portal-select
                id="workCountry"
                formControlName="workCountry"
                [items]="countryList"
                [withFilter]="true"
                [clearable]="true"
                placeholder="Country"
                itemId="id"
                itemName="name"
                (selectionChange)="getStates(workAddressFormGroup.get('workState'), workAddressFormGroup.get('workCounty'), $event)">
                <ng-template let-item #option>
                  {{item?.name}}
                </ng-template>
              </app-portal-select>
              <span *ngIf="tooltipService.getState('workCountry')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('workCountry', defaultRequired, defaultExists, defaultInvalid)"
                [position]="'below'"
                [fieldName]="'Country'">
              </app-tooltip>
            </span>
            </div>
            <div class="input-wrap">
              <label for="workPhone">Telephone Number <span class="required-symbol">*</span></label>
              <app-portal-select
                formControlName="workPrefix"
                [items]="countryList"
                [prefix]="workPrefix"
                (onSelectionChange)="setWorkPrefix($event)"
                placeholder="Select"
                itemId="id">
                <ng-template let-item #option>
                  <img alt="flag"
                       class="img-responsive img-flag-country"
                       src="/assets/flags/{{item?.code.toLowerCase()}}.png"> {{item.name | titlecase}}
                  +{{item.phoneCode}}
                </ng-template>
              </app-portal-select>
              <input appInputTrimmer class="phone-number" formControlName="workPhone" id="workPhone"
                     placeholder="Telephone Number"/>
              <span *ngIf="tooltipService.getState('workPhone')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('workPhone', defaultRequired, defaultExists, defaultInvalid)"
                [position]="'below'"
                [fieldName]="'Telephone Number'">
              </app-tooltip>
            </span>
            </div>
            <div class="input-wrap">
              <label for="workFax">Fax Number</label>
              <app-portal-select
                formControlName="workFaxPrefix"
                [items]="countryList"
                [prefix]="workFaxPrefix"
                (onSelectionChange)="setWorkFaxPrefix($event)"
                placeholder="Select"
                itemId="id">
                <ng-template let-item #option>
                  <img alt="flag"
                       class="img-responsive img-flag-country"
                       src="/assets/flags/{{item?.code.toLowerCase()}}.png"> {{item.name | titlecase}}
                  +{{item.phoneCode}}
                </ng-template>
              </app-portal-select>
              <input appInputTrimmer class="phone-number" formControlName="workFax" id="workFax"
                     placeholder="Fax Number"/>
              <span *ngIf="tooltipService.getState('workFax')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('workFax', defaultRequired, defaultExists, defaultInvalid)"
                [position]="'below'"
                [fieldName]="'Fax Number'">
              </app-tooltip>
            </span>
            </div>
          </form>
          <div class="save-changes">
            <cmp-button
              (onClick)="saveWorkAddress()"
              class="outline-primary"
              text="Save Changes"
              [loading]="saveBtnLoading">
            </cmp-button>
          </div>
        </div>
      </div>

      <div *ngIf="licenses && !isGlobalAdmin" class="section-fill">
        <div class="user-form-title d-flex align-items-center justify-content-between mb-30">
          <div class="main-title m-0">
            <h5>Licenses</h5>
          </div>
          <button (click)="cancel()" class="close" data-dismiss="modal" type="button">&times;</button>
        </div>
        <div>

          <div class="ucx-accordion">
            <div class="ucx-accordion-header">
              <a (click)="onAddNewLicense()" class="add-new">Add License</a>
            </div>
            <div *ngIf="licenceData"
                 [ngClass]="{'ucx-accordion-body': true, 'card-empty': (!licenceData || !licenceData.length) }">
              <ul *ngIf="licenceData">
                <li *ngFor="let license of licenceData; let i = index" class="stripe-card">

                  <div *ngIf="license" class="card-item">
                    <!-- Card Info -->
                    <div class="card-item-info">
                      <div class="card-info">
                        <p>
                          <span class="card-number">License number: {{ license.licenseNumber }}</span>
                        </p>
                        <p>
                          <span class="card-number">Country issued: {{ license.countryIssued?.name }} </span>
                        </p>
                        <p *ngIf="!!license.stateIssued">
                          <span class="card-number">State issued: {{ license.stateIssued?.name }}</span>
                        </p>
                        <p>
                          <span
                            class="card-number">Effective date:  {{datePipe.transform(license.effectiveDate, dateformat)}}  </span>
                        </p>
                        <p>
                          <span
                            class="card-number">Expiration/Renewal Date:  {{datePipe.transform(license.expirationDate, dateformat)}}  </span>
                        </p>
                      </div>
                    </div>
                    <!-- License Actions -->
                    <div class="card-item-actions">
                      <ul>
                        <li class="card-default">
                          <i (click)="onUpdateLicense(i)" class="material-icons delete-icon">edit</i>
                        </li>
                        <li *ngIf="!isLicenseMandatory" class="card-default">
                          <i (click)="removeLicense(i)" class="material-icons delete-icon">delete</i>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
              </ul>
              <p *ngIf="(!licenceData || !licenceData.length)">You have not added any Licenses yet, please press "Add
                new" to add your
                License.</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
